import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from './url.service';
import { QuestionnaireCsrdConfigDto } from 'app/@types/dto/questionnaire-csrd-config-dto.model';

@Injectable({
    providedIn: 'root',
})
export class QuestionnaireCsrdConfigHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    get(orgId: string): Observable<QuestionnaireCsrdConfigDto> {
        return this.http.get<QuestionnaireCsrdConfigDto>(this.urlService.getQuestionnaireCsrdConfig(orgId));
    }
}
